import type {
  Menu,
  Module,
  Page,
  SubPage,
  SidebarMenuDirectus,
  SidebarItemsDirectus,
  PageDirectus,
  SubPageDirectus,
  MenuPageRelationDirectus,
} from "@/types/models/menu"
import { bySort, toNumber } from "@/lib/utils"

interface MapMenuParams {
  menu: SidebarMenuDirectus
  sidebarItems: SidebarItemsDirectus[]
  pages: PageDirectus[]
  subpages: SubPageDirectus[]
  tenantRelations: MenuPageRelationDirectus[]
}

export const mapSubPage = (subpage: SubPageDirectus): SubPage => ({
  text: subpage.text,
  slug: subpage.slug,
  translations: subpage.translations,
})

export const mapPage = (
  page: PageDirectus,
  subpages: SubPageDirectus[]
): Page => ({
  text: page.text,
  slug: page.slug,
  icon: page.icon,
  translations: page.translations,
  subpages: bySort(
    subpages.filter((subpage) => toNumber(subpage.page) === toNumber(page.id))
  ).map(mapSubPage),
})

export const mapModule = (
  sidebarItem: SidebarItemsDirectus,
  pages: PageDirectus[],
  subpages: SubPageDirectus[]
): Module => ({
  text: sidebarItem.text,
  translations: sidebarItem.translations,
  page: bySort(
    pages.filter(
      (page) => toNumber(page.sidebarItem) === toNumber(sidebarItem.id)
    )
  ).map((page) => mapPage(page, subpages)),
})

export function mapMenu({
  menu,
  sidebarItems,
  pages,
  subpages,
  tenantRelations,
}: MapMenuParams): Menu {
  const allowedPageIds = new Set(
    tenantRelations.map(({ pages_id }) => toNumber(pages_id))
  )

  const allowedPages = pages.filter((page) =>
    allowedPageIds.has(toNumber(page.id))
  )

  const allowedSubpages = subpages.filter((subpage) =>
    allowedPageIds.has(toNumber(subpage.page))
  )

  const modules = bySort(sidebarItems)
    .map((item) => mapModule(item, allowedPages, allowedSubpages))
    .filter(({ page }) => page.length)

  return {
    image: menu.image,
    image_dark: menu.image_dark,
    footer: menu.footer,
    link: menu.link,
    module: modules,
  }
}
